import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearData as clearAnalysisData } from 'src/redux/slices/analysis/reducers'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
import { deleteProject, getProject } from 'src/redux/slices/project/endpoints'
import { deactivateProject } from 'src/redux/slices/project/reducers'
import { isLoading } from 'src/redux/slices/project/selectors'
import {
  clearAllData as clearUmibuilderData,
  setCloudContext,
} from 'src/redux/slices/umibuilder/reducers'
import { clearAllData as clearUpgradesData } from 'src/redux/slices/upgrades/reducers'

import { Button, Grid } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'

///// Component
const DeleteProjectWidget: React.FC = () => {
  const dispatch = useDispatch()
  const { data: project } = getProject.useQuery('')
  const [trigger, { data }] = deleteProject.useMutation()
  const loading = useSelector(isLoading)
  const { goToTab } = useTabNavigation()
  const deleteAndLeave = useCallback(() => {
    if (!project?.id) return
    dispatch(deactivateProject())
    dispatch(setCloudContext(false))
    dispatch(clearUmibuilderData())
    dispatch(clearUpgradesData())
    dispatch(clearAnalysisData())
    trigger({ id: project.id, includeFiles: false })
    goToTab('../account/projects')
  }, [project, trigger, goToTab, dispatch])
  return (
    <Grid container justifyContent='center'>
      <Grid item>
        <Button
          variant='contained'
          onClick={deleteAndLeave}
          color='primary'
          endIcon={<DeleteIcon />}
          startIcon={<DeleteIcon />}
          disabled={loading}
        >
          Delete Project
        </Button>
      </Grid>
    </Grid>
  )
}

export default DeleteProjectWidget
